import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField
} from '@material-ui/core';
import React, { FC, memo, ChangeEvent } from 'react';

interface DecisionDialogProps {
  isOpen: boolean;
  title?: string;
  subTitle?: string;
  okayButtonName?: string;
  onHandleConfirmAction: () => void;
  onHandleClose: () => void;

  // Optional reason box props
  showReasonBox?: boolean;
  reasonLabel?: string;
  reasonValue?: string;
  onReasonChange?: (value: string) => void;
}

const component: FC<DecisionDialogProps> = ({
  isOpen,
  title,
  subTitle,
  okayButtonName = 'Confirm',
  onHandleConfirmAction,
  onHandleClose,

  showReasonBox = false,
  reasonLabel = 'Reason',
  reasonValue = '',
  onReasonChange
}) => {
  const onHandleConfirm = () => {
    onHandleConfirmAction();
    onHandleClose();
  };

  const handleReasonChange = (e: ChangeEvent<HTMLInputElement>) => {
    onReasonChange?.(e.target.value);
  };

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={onHandleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography style={{ fontWeight: 700, fontSize: '20px' }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {subTitle && (
          <DialogContentText id="alert-dialog-description">
            <Typography style={{ fontSize: '16px' }}>{subTitle}</Typography>
          </DialogContentText>
        )}

        {showReasonBox && (
          <TextField
            label={reasonLabel}
            multiline
            rows={4}
            variant="outlined"
            value={reasonValue}
            onChange={handleReasonChange}
            fullWidth
            margin="normal"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onHandleConfirm} color="primary" autoFocus>
          {okayButtonName}
        </Button>
        <Button onClick={onHandleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const DecisionDialog = memo(component);
